import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import Cookies from 'js-cookie'
import authApi from '../../redux/api/auth';
import telemetryController from '../../redux/api/tbTelemetryController';
import { toast } from 'react-toastify';
import userController from '../../redux/api/tbUserController';

export const initialState = {
  profile: '',
  status: 'idle',
};

export const changePassword = createAsyncThunk(
  'changePassword',
  async (data) => {
    const { oldPassword, confirmPassword, token } = data;
    const changePass = await authApi.postChangePassword(
      oldPassword,
      confirmPassword,
      token
    );
    if (changePass.token) {
      toast.success('Change password successfully.');
    }

    localStorage.setItem('token', changePass.token);
    Cookies.set('refreshToken', changePass.refreshToken, { expires: 7 });

    return changePass;
  }
);

export const getDataUser = createAsyncThunk('getUser', async (token) => {
  const user = await authApi.getUser(token);
  const result = await telemetryController.getPermission(
    token,
    'USER',
    user.id.id
  );
  let allRoles;
  Object.values(result).map((item) => {
    if (item['key'] === 'role') allRoles = item.value;
  });
  return {
    ...user,
    attributes: {
      role: allRoles,
    },
  };
});

export const saveUserName = createAsyncThunk('saveUserName', async (data) => {
  const { token, user } = data;
  const response = await userController.saveUser(token, user);
  return response;
});

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //change password
    builder.addCase(changePassword.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.status = 'idle';
      state.profile = action.payload;
    });
    builder.addCase(changePassword.rejected, (state) => {
      state.status = 'failed';
      state.profile = [];
      toast.error('Old Password is not correct.');
    });

    //get user
    builder.addCase(getDataUser.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getDataUser.fulfilled, (state, action) => {
      state.status = 'idle';
      state.profile = action.payload;
    });
    builder.addCase(getDataUser.rejected, (state) => {
      state.status = 'failed';
      state.profile = [];
    });

    //saveUserName
    builder.addCase(saveUserName.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(saveUserName.fulfilled, (state) => {
      state.status = 'idle';
      toast.success('Change user name successful.');
    });
    builder.addCase(saveUserName.rejected, (state) => {
      state.status = 'failed';
    });
  },
});

export default profileSlice.reducer;

export const allUserInfos = (state) => state.profile.profile;
